import React from "react";
import { pipe } from "ramda";
import { Tooltip } from "../../../core";

const calculateType = ({ calendar_name, campaign_name }) => {
  if (calendar_name) {
    return { type: "calendar" };
  }
  if (campaign_name) {
    return { type: "campaign" };
  }
  return { type: null };
};
const formatMediaType = ({ type }) => {
  if (type === "calendar") {
    return <span className="networkPlaying">Calendar</span>;
  }
  if (type === "campaign") {
    return <span className="networkPlaying">Campaign</span>;
  }
  return null;
};
const formatedStatus = pipe(
  calculateType,
  formatMediaType
);

function checkLength(word, limit = 25) {
  if (word && word.length > limit) {
    return `${word.slice(0, limit)}...`;
  }
  return word;
}

export const toolTipsValueCalculator = (text, id, limit = 25, current) => (
  <Tooltip
    item={<span className="mb-1">{checkLength(text, limit)}</span>}
    id={`viewname-${id}-${limit}-${current}`}
    tooltipContent={text}
  />
);

export const formatCurrentlyPlaying = (
  { campaign_name, calendar_name, id },
  current
) => {
  if (campaign_name || calendar_name) {
    return (
      <React.Fragment>
        {toolTipsValueCalculator(
          campaign_name || calendar_name,
          id,
          25,
          current
        )}
        {formatedStatus({ campaign_name, calendar_name })}
      </React.Fragment>
    );
  }
  return <span>None</span>;
};

export const formatCurrentlyPlayingForGrid = (
  { campaign_name, calendar_name, id },
  current
) => {
  if (campaign_name || calendar_name) {
    return (
      <div>
        <span className="mt-1 d-flex">
          <i
            className="mt-1 fa fa-play"
            style={{ fontSize: "10px", cursor: "default" }}
          />
          <span className="ml-1 mr-1">|</span>
          {toolTipsValueCalculator(
            campaign_name || calendar_name,
            id,
            25,
            current
          )}
        </span>

        {formatedStatus({ campaign_name, calendar_name })}
      </div>
    );
  }
  return <span>Not Playing</span>;
};
